// Display a countdown in hours, minutes and seconds.
// Example call: javascript_countdown.init(number_of_seconds, 'target_element_name');

const javascript_countdown = function () {
    var time_left = 10; //number of seconds for countdown
    var output_element_id = 'javascript_countdown_time';
    var keep_counting = 1;
    var no_time_left_message = '<flash>00:00:00</flash>';
    var initialised = false;

    function countdown() {
        if (time_left < 2) {
            keep_counting = 0;
        }

        time_left = time_left - 1;
    }

    function add_leading_zero(n) {
        if (n.toString().length < 2) {
            return '0' + n;
        } else {
            return n;
        }
    }

    function format_output() {
        var days,hours, minutes, seconds;
        seconds = time_left % 60;
        minutes = Math.floor(time_left / 60) % 60;
        hours = Math.floor(time_left / 3600) % 24;
        days = Math.floor(time_left / 86400);

        seconds = add_leading_zero(seconds);
        minutes = add_leading_zero(minutes);
        hours = add_leading_zero(hours);

        var daysPart = "";
        if (days > 0) {
            daysPart = days + " days ";
        }
        
        return daysPart + hours + ':' + minutes + ':' + seconds;
    }

    function show_time_left() {
        const element = document.getElementById(output_element_id);
        if (!element || element=== null) {
            return;
        }
        element.innerHTML = format_output(); //time_left;
    }

    function no_time_left() {
        const element = document.getElementById(output_element_id);
        if (!element || element === null) {
            return;
        }
        element.innerHTML = no_time_left_message;
    }


    function count() {
        countdown();
        show_time_left();
    }

    function timer() {
         count();

        if (keep_counting) {
            setTimeout(timer, 1000);
        } else {
            no_time_left();
        }
    }

    function setTimeLeft(t) {
        time_left = t;
        if (keep_counting == 0) {
            timer();
        }
    }


    function init(t, element_id) {
        if (initialised) {
            return;
        }
        initialised = true;
        time_left = t;
        output_element_id = element_id;
        timer();
    }


    return {
        count,
        timer,
        setTimeLeft,
        init
    };
}();


export default javascript_countdown;
 
